module.exports = __webpack_public_path__ + "static-portal/img/32-1.906696c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/32-1.jpg
// module id = PDEf
// module chunks = 4